import React from 'react';
import classes from './Burger.module.css';
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';
import {withRouter} from 'react-router-dom';

const burger=(props)=>{

    let transformedIngredients=(Object.keys(props.ingredients)).map(igKey=>{
            return [...Array(props.ingredients[igKey])].map((_,i)=>{
               return <BurgerIngredient type={igKey}/>
            })
        })
        .reduce((arr,el)=>{
            return arr.concat(el)
        },[]);
    if(transformedIngredients.length === 0){
        transformedIngredients=<p>Add some ingredients doe</p>
    }    

    return(
        <div className={classes.Burger} >
            <BurgerIngredient type="bread-top"/>
            {transformedIngredients}
            <BurgerIngredient type="bread-bottom"/>
        </div>
    );
};
//className={classes.Burger}
export default withRouter(burger);
